import { PIE_DONUT_TRESHOLD } from '../config';
import interaction from './interaction';
import overlay from '../popup/overlay';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Chart from '../chartStyle/index';
import { replaceAll } from '../helpers';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import Collection from 'ol/Collection';
import { isLayerAdded, isZoomGroupChanged } from '../map/helpers';
import { LoadingState } from '../loading/state';
import { DEFAULT_ZOOM_GROUPS } from '../config';

export const VALUE_FIELD = 'grouping';
export const GROUP_FIELD = 'address'; //'Apaksnozar';

let customSlideValue = null;
export const setCustomSlideValue = (value) => {
	customSlideValue = value;
}

var oldIndustries = [];
var oldRadius = 0;

var RequestCount = 0; //to prevent dublicate requests

const SOURCE_URL = '/api?action=getdata&xmin=%XMIN%&ymin=%YMIN%&xmax=%XMAX%&ymax=%YMAX%&zoom=%ZOOM%&industries=%INDUSTRIESLIST%';

const CLUSTER_ZOOM_THRESHOLD = 14;

const zoomGroups = DEFAULT_ZOOM_GROUPS;

export const CAT_NAMES = [
	'Deportētie iedzīvotāji',
	'1941. gada 14. jūnijs',
	'1949. gada 25. marts',
	'Citas deportācijas 1945.—1953.',
	'Piemiņas pasākumi',
	'14. jūnijs',
	'25. marts',
	'Piemiņas pasākumi pasaulē'
];

let currentAbort = new AbortController();

const cancelFetchOnReentry = (wrappedFunc) => {
	return async (...args) => {
		currentAbort.abort();
		currentAbort = new AbortController();

		let mySignal = currentAbort.signal;

		const injectedFetch = (input, init) =>
			fetch(input, { ...init, signal: mySignal });

		try {
			await wrappedFunc(injectedFetch)(...args);

		} catch (ex) {
			if (ex.name === 'AbortError') {
				return; // Request has been canceled, so do nothing
			}

			throw ex;
		}
	};
};

export default class industries {
	constructor({map, activeIndustries, colorMap, radiusMod, selectFeature, pieSizeCallback}) {
		this.map = map;
		this.activeIndustries = activeIndustries;
		this.colorMap = colorMap;
		this.radiusMod = radiusMod;

		this.prevZoom = map.getView().getZoom();

		this.styleCache = {};
		this.VALUE_FIELD = VALUE_FIELD;
		this.GROUP_FIELD = GROUP_FIELD;
		this.selectFeature = selectFeature;
		this.pieSizeCallback = pieSizeCallback;

		this.generateStyle = this.generateStyle.bind(this)

		var this_ = this;

		var interactionRemoved = false;

		this.vectorSource = new VectorSource({
			format: new GeoJSON(),
			useSpatialIndex: true,
			loader: function(a, b, c, d) {
				RequestCount++;

				LoadingState.toggleActive(true);
				var extent = this_.map.getView().calculateExtent();

				var zoom = this_.map.getView().getZoom();
				if (zoom < CLUSTER_ZOOM_THRESHOLD) {
					// return;
				}

				const deportedCategories = [CAT_NAMES[1], CAT_NAMES[2], CAT_NAMES[3]];
				let dataGroup = this_.activeIndustries[0];

				if (deportedCategories.includes(dataGroup)) {
					dataGroup = dataGroup.slice(0, 5);
					dataGroup = dataGroup.replace('.', '');
					dataGroup = dataGroup.toLowerCase();

				} else {
					dataGroup = '';
				}

				var urlIn = replaceAll(SOURCE_URL, {
					'%XMIN%': extent[0],
					'%YMIN%': extent[1],
					'%XMAX%': extent[2],
					'%YMAX%': extent[3],
					'%ZOOM%': zoom,
					'%INDUSTRIESLIST%': dataGroup,
				});

				const loadData = cancelFetchOnReentry((fetch) => async (url) => {
					let response = await fetch(url);
					let data = await response.json();

					RequestCount--;

					if (RequestCount > 0) {
					//	return;
					}

					var featuresCollection = this.getFeaturesCollection();
					if (featuresCollection instanceof Collection){
						featuresCollection.clear();
					}

					var features = (new GeoJSON()).readFeatures(data);
					this_.pieSizeFunc(features);

					this.addFeatures(features);

					if (this_.interaction && !interactionRemoved) {
						this_.interaction.disable();
						this_.map.removeInteraction(this_.interaction);
					}

					this_.interaction = interaction({
						map: this_.map,
						layers: [this_.vectorLayerIndustries],
						selectFeature: (feature, index) => {
							if (feature) {
								var features = feature.getProperties().data;
								this_.selectFeature(features, features[0][this_.GROUP_FIELD]);

							} else {
								this_.selectFeature([]);
							}
						},
						selectStyle: this_.generateStyle,
						radiusFunc: this_.radiusFunc,
						sectorFunc: this_.sectorFunc, //return sector values, example: [50, 23, 53]
						pie_donut_treshold: PIE_DONUT_TRESHOLD,
						overlay: this_.overlay
					});

					this_.map.addInteraction(this_.interaction);

					LoadingState.toggleActive(false);
				});

				loadData(urlIn);
			}
		})

		this.vectorLayerIndustries = new VectorLayer({
			renderMode: 'image',
			style: this.generateStyle,
			group: 'student_schools',
			source: this.vectorSource,
			zIndex: 20
		});

		this.interaction = null;
		this.attachZoomEvent();
		this.stateUpdateHandler = this.stateUpdateHandler.bind(this);

		this.selectStyle = this.selectStyle.bind(this);
		this.radiusFunc = this.radiusFunc.bind(this);
		this.sectorFunc = this.sectorFunc.bind(this);
		this.zoomEvent = this.zoomEvent.bind(this);

		this.zoomEventAttached = false;

		this.overlay = overlay();
	}

	pieSizeFunc(featuresIn) {
		if (featuresIn) {
			var features = featuresIn;

		} else {
			var features = this.vectorSource.getFeatures();
		}

		if (features === null) {
			return;
		}

		var topRadius = 0;
		var secondTopRadius = 0;

		for (var i = features.length - 1; i >= 0; i--) {
			var radius = this.radiusFunc(features[i], true);

			if (radius > topRadius) {
				topRadius = radius;

			} else if (radius <= topRadius && radius > secondTopRadius) {
				secondTopRadius = radius;
			}
		}

		if (this.activeIndustries[0] == CAT_NAMES[3]) {
			this.pieSizeCallback(topRadius, customSlideValue);

		} else {
			this.pieSizeCallback(secondTopRadius, customSlideValue);
		}
	}

	update() {
		if (this.activeIndustries.length === 0) {
			if (isLayerAdded(this.vectorLayerIndustries, this.map)) {
				this.map.removeLayer(this.vectorLayerIndustries);
			}

			return;
		}

		if (!isLayerAdded(this.vectorLayerIndustries, this.map)) {
			this.map.addLayer(this.vectorLayerIndustries);
		}

		return;
	}

	zoomEvent(evt, hvz) {
		var currentZoom = this.map.getView().getZoom();

		if (isZoomGroupChanged(currentZoom, this.prevZoom, zoomGroups)) {
			customSlideValue = null;
			this.vectorSource.clear();

		} else if (currentZoom >= CLUSTER_ZOOM_THRESHOLD) {
			this.vectorSource.clear();

		} else {
			//cal pie size update only if group hasn't changed. There seprate call of thispieSizeFunc in source callback when features update
			this.pieSizeFunc();
		}

		this.prevZoom = currentZoom;
	}

	findFeaturesInPieIndex(f, index) {
		var {indexFeatures} = this.getCategoriesSums(f, true, true);

		return indexFeatures[index];
	}

	radiusFunc(f, nomod = false) {
		return this.getRadius(f, !nomod);
	}

	sectorFunc(f) {
		var {catArray} = this.getCategoriesSums(f);

		return catArray;
	}

	selectStyle(f, res) {
		return this.generateStyle(f, resolution, selectIndex);
	}

	changes(newIndustries, radiusMod) {
		if (newIndustries.length !== oldIndustries.length) {
			oldIndustries = newIndustries;
			return true;

		} else {
			for (var i = newIndustries.length - 1; i >= 0; i--) {
				if (oldIndustries.indexOf(newIndustries[i]) === -1) {
					oldIndustries = newIndustries;
					return true;
				}
			}
		}

		return false;
	}

	stateUpdateHandler({activeIndustries, colorMap, radiusMod, selectFeature, pieSizeCallback}) {
		if (oldRadius !== radiusMod) {
			oldRadius = radiusMod;
			this.radiusMod = radiusMod;
			this.vectorLayerIndustries.changed();
		}

		if (!this.changes(activeIndustries, radiusMod)) {
			return;
		}

		if (this.interaction !== null) {
			this.interaction.clear();
		}

		this.vectorSource.clear();

		this.activeIndustries = activeIndustries;
		this.colorMap = colorMap;
		this.styleCache = {};
		this.pieSizeCallback = pieSizeCallback;

		this.selectFeature = selectFeature;

		if (this.overlay == null) {
			this.overlay = overlay();
		}

		this.attachZoomEvent();
		this.update();
	}

	attachZoomEvent() {
		if (typeof this.activeIndustries !== 'undefined' && this.activeIndustries.length > 0 && !this.zoomEventAttached) {
			this.zoomEventAttached = true;
			this.map.on('moveend', this.zoomEvent);

			if (this.interaction !== null) {
				this.map.addInteraction(this.interaction);
			}

		} else if(this.zoomEventAttached && typeof this.activeIndustries !== 'undefined' && this.activeIndustries.length === 0){
			this.zoomEventAttached = false;
			this.map.un('moveend', this.zoomEvent);
			this.map.removeInteraction(this.interaction);
		}
	}

	getCategoriesSums(feature, getCatSums = true, pieIndexFeatures = false) {
		var features = feature.getProperties().features;

		if (typeof features === 'undefined') {
			features = feature.getProperties().data;
		}

		var catArray = []; //
		var catNameIndexValueMap = {}; //category array index map
		var IndexValueCatNameMap = {}; //the same but reversed values keys
		if (pieIndexFeatures) {
			var indexFeatures = [];
		}

		var sum = 0;

		if (typeof features !== 'undefined' && features instanceof Array) { //array
			for (var i = features.length - 1; i >= 0; i--) {

				if (typeof features[i].getProperties !== 'undefined') {
					var props = features[i].getProperties();
				} else {
					var props = features[i];
				}

				var groupProp = props[this.GROUP_FIELD];
				var valueProp = props[VALUE_FIELD];

				if (getCatSums) {
					if (typeof catNameIndexValueMap[groupProp] === 'undefined') {
						catArray.push(0);
						catNameIndexValueMap[groupProp] = catArray.length - 1;
						IndexValueCatNameMap[catArray.length - 1] = groupProp;
					}

					catArray[catNameIndexValueMap[groupProp]] += valueProp;

					if (pieIndexFeatures) {
						if (typeof indexFeatures[catNameIndexValueMap[groupProp]] === 'undefined') {
							indexFeatures[catNameIndexValueMap[groupProp]] = [];
						}

						indexFeatures[catNameIndexValueMap[groupProp]].push(features[i]);
					}
				}

				sum += valueProp;
			}
		}

		if (getCatSums) {
			return {catArray, catNameIndexValueMap, IndexValueCatNameMap, sum, indexFeatures};

		} else {
			return sum;
		}
	}

	getFeaturesCount(feature) {
		var subFeatures = feature.getProperties().features

		if (typeof subFeatures === 'undefined') {
			subFeatures = feature.getProperties().data;
		}

		if (typeof subFeatures !== 'undefined') {
			return subFeatures.length == 1 && !subFeatures[0].address && !subFeatures[0].nosaukums1 ? subFeatures[0].count : subFeatures.length;

		} else {
			return 1;
		}
	}

	getRadius(f, useMod = true) {
		const mod = useMod ? this.radiusMod : 1;

		let intRadius = Math.sqrt(this.getFeaturesCount(f) / Math.PI) * mod * 15;

		if (intRadius < 5){
			intRadius = 5;
		}

		return intRadius;
	}

	generateStyle(f, resolution, selectedSectorIndex = false) {
		return ((feature) => {

			var {catArray, IndexValueCatNameMap, sum} = this.getCategoriesSums(feature);
			var intRadius = this.getRadius(feature);

			var valueArray = [[100, 'rgb(66 113 117)', 1, 0, null, 1]];

			if (valueArray.length === 0) {
				return;
			}

			var strCache = '';
			for (var i = valueArray.length - 1; i >= 0; i--) {
				var valarr = valueArray[i];

				strCache += '' + valarr[0] + '' + valarr[1] + '' + valarr[2] + '' + valarr[3] + '' + valarr[5];
			}

			var type = (intRadius <= PIE_DONUT_TRESHOLD ? 'pie' : 'donut');

			strCache += intRadius;
			strCache += selectedSectorIndex;

			//add cacheing
			if (!this.styleCache[strCache]) {
				// Create chart style
				var c = $("#color").val();
				var style = new Style({ //this.styleCache[strCache]
					image: new Chart({
						type: type,
						sectors: false, // pieChartState.pieSectors,
						radius: intRadius,
						scale: 1,
						offsetY: 0,
						selectedSector: ((selectedSectorIndex !== false) ? selectedSectorIndex : undefined),
						data: valueArray, // [[color, size, xxx, fillpattern, featureRef, xxx], ...]
						colors: 'pastel',
						rotateWithView: true,
						animation: false,
						stroke: new Stroke({
							color: "#fff",
							width: 2
						}),
					}),
					zIndex: Math.round(1000000 - intRadius)
				});

			} else {
				var style = this.styleCache[strCache];
			}

			return [style];
		})(f);
	}
}



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mapData/mapDataMap.js